import { useUiResourceContext, useResultContext } from 'common/components/CopyMagic/contexts';

const useDiscard = () => {
  const { setShowDiscardModal, setOpen, cancelPendingRequest } = useUiResourceContext();
  const { result } = useResultContext();

  const discard = () => {
    if (result) setShowDiscardModal(true);

    setOpen(false);
    cancelPendingRequest();
  };

  return {
    discard,
  };
};

export default useDiscard;
